import * as React from 'react';
import "./CheckElement.scss";
import { useCallback, useState, ChangeEvent } from 'react';
import { CheckProps, CheckDefines } from './ICheck';
import { ElementType } from '../../common/enum/elementType';
import InputElement from '../core/InputElement';
import useActionExecutor from '../service/actionExecutor';
import { ColorDefines } from '../../interface/IColors';

interface CheckElementProps {
  props: CheckProps;
  defines: CheckDefines;
  colors: ColorDefines;
}

const CheckElement = ({ props, defines, colors }: CheckElementProps) => {
  const [touched, setTouched] = useState(false);
  const [focus, setFocus] = useState(false);
  const [value, setValue] = useState(props.value || defines.defaultValue);
  const { change } = useActionExecutor(props.event, defines);
  const onchange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setTouched(true);
    if (props.setTouched) props.setTouched(true);
    setValue(!value);
    if (change) change(e);
  }, [value, setValue]);

  return (
    <InputElement
      type={ElementType.CHECK}
      value={value}
      touched={touched}
      dispatchValid={props.dispatchValid}
      {...{ props, defines }}
    >
      <label className={focus ? " focus" : ""}>
        <div className={"checkbox" + (value ? " checked" : "") + (touched ? " touched" : "")}>
          <div className="core"></div>
        </div>
        <input
          type="checkbox"
          name={defines.name}
          style={{
            position: "absolute", pointerEvents: "none", opacity: 0
          }}
          checked={!!value}
          onFocus={_ => setFocus(true)}
          onBlur={_ => setFocus(false)}
          onChange={onchange}/>
        {defines.label}
      </label>
    </InputElement>
  )
}

export default CheckElement;